import { formatTimeInTimezone } from '../../utils/warehouseDates'
import { NEEDS_LABEL_OUTCOMES } from './states'
import { OutcomeBadge } from './OutcomeBadge'
import { RowActionButton } from './RowActionButton'
import { useNamespacedT } from './useNamespacedT'

const T = 'c2c_receiving.processed'

// Zone C (spec §5.4): what THIS browser processed for this warehouse. Reimprimir replays
// the label endpoint (returns the existing labels of a shipped order); Generar guía runs
// the label step for an entry whose label hasn't succeeded yet ('pending' or 'label_failed').
export const ProcessedStrip = ({ entries, canScan, busy, busyOrderId, timeZone, onLabelAction }) => {
  const t = useNamespacedT(T)

  if (!entries || entries.length === 0) return null

  return (
    <div className="bg-white rounded-lg border border-gray-200 px-4 py-3 mb-4">
      <h2 className="text-sm font-semibold text-gray-700 mb-2">{t('title')}</h2>
      <ul className="divide-y divide-gray-100">
        {entries.map(entry => {
          const order = entry.order
          const needsLabel = NEEDS_LABEL_OUTCOMES.includes(entry.outcome)
          return (
            <li key={order.id} className="flex flex-wrap items-center gap-3 py-2 text-sm">
              <span className="font-mono text-gray-900">{order.roll_code}</span>
              <span className="text-gray-700">{order.receiver_name || '-'}</span>
              <span className="text-gray-500">{order.destination_point_name || ''}</span>
              <OutcomeBadge outcome={entry.outcome} />
              <span className="text-xs text-gray-500">{formatTimeInTimezone(entry.at, timeZone) ?? '-'}</span>
              <span className="ml-auto">
                <RowActionButton
                  order={order}
                  label={t(needsLabel ? 'generate_label' : 'reprint')}
                  type={needsLabel ? 'primary' : 'secondary'}
                  canScan={canScan}
                  busy={busy}
                  busyOrderId={busyOrderId}
                  onClick={onLabelAction}
                />
              </span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
